import { createQueryParams } from '@/utils/query-params';
import { api } from './index';
import { type Caregiver } from './caregivers';

const BASE_PATH = '/api/internal/available_caregivers';

export type AvailableCaregiversParams = {
  shiftId: number;
} | {
  patientId: number;
  startDatetime: string;
  endDatetime: string;
};

export const availableCaregiversApi = {
  index(params: AvailableCaregiversParams): Promise<Array<Caregiver>> {
    const queryString = createQueryParams(params);

    return api({
      method: 'get',
      url: `${BASE_PATH}?${queryString}`,
    }).then(response => response.data.caregivers);
  },
};
